export const Environments = {
  Development: "Development",
  Test: "Test",
  Production: "Production",
} as const;

export type Environment = keyof typeof Environments;

export const envLabels: Record<Environment, Environment> = {
  Development: "Development",
  Test: "Test",
  Production: "Production",
};

export const envColors: Record<Environment, string> = {
  Development: "bg-green-500",
  Test: "bg-yellow-500",
  Production: "bg-red-500",
};

export const getEnvironment = (): Environment => {
  const isTest = import.meta.env.VITE_TEST === "true";

  if (isTest) return Environments.Test;
  if (import.meta.env.PROD) return Environments.Production;

  return Environments.Development;
};

export const isTestEnvironment = () => import.meta.env.VITE_TEST === "true";
